import {
    Container,
    Content,
    Controls,
    Wrapper
} from './styled';
import { IoIosClose } from 'react-icons/io';
import { Charts } from '../../components';

export function ChartFull(props) {

    const { onClose, title, dataChart: { type, data } } = props;


    const RenderControls = () => {
        return (
            <Controls>
                <div>
                    <span>
                        {title}
                    </span>
                </div>
                <div>
                    <span>
                        <IoIosClose
                            className='icon--close'
                            onClick={() => onClose()}
                        />
                    </span>
                </div>
            </Controls>
        )
    };

    return (
        <Container>
            <Content>
                <RenderControls />
                <Wrapper>
                    <Charts
                        type={type}
                        data={data}
                    />
                </Wrapper>
            </Content>
        </Container>
    )
}